import { useOneTrustAfterLogin } from './useOneTrust';
import { useSettings } from '../stateManagement/SettingsContext';
// import { useAuth } from '../stateManagement/auth/useAuth';

export const OneTrustInitializer = () => {
  const { settings } = useSettings();
  // const { isAuthenticated } = useAuth(); // <- You must add this or a similar hook

  const showOneTrustConsent = settings?.configs.useOneTrust ?? false;
  const oneTrustScriptId = settings?.configs.oneTrustScriptId ?? '';

  useOneTrustAfterLogin(showOneTrustConsent, oneTrustScriptId);

  return null; // no visual component
};
